import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAcubeService } from "../../service/acube-api.hook";
import { useAppContext } from "../../context/app-context";
import LoadingScreen from "../../components/loader/loading-screen";
import "../../components/header/header.css";

const BlogLayout = () => {
  const { getProxy, postProxy } = useAcubeService();
  const { slug } = useParams(); // Fetch UUID from the URL
  const [blogData, setBlogData] = useState(null);
  const [isViewed, setIsViewed] = useState(false);
  const { ipAddress } = useAppContext();

  const fetchBlogData = async () => {
    try {
      const result = await getProxy(`blog/details/${slug}`);
      const data = result.data?.length ? result.data[0] : result.data;
      setBlogData(data);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  // const addViewsCount = async () => {
  //   try {
  //     const payload = { blogUUID: id };
  //     await postProxy(`blog/views`, payload);
  //   } catch (error) {
  //     console.error("Error adding view count:", error);
  //   }
  // };

  useEffect(() => {
    // Ensure fetching and view count addition is done only when necessary
    if (slug && ipAddress && !isViewed) {
      fetchBlogData().then(() => {
        // addViewsCount();
        setIsViewed(true); // Set this only after fetching data
      });
    }
  }, [slug, ipAddress, isViewed]); // Dependencies to check for changes

  return (
    <>
      <div className="blogs-section">
        {blogData ? (
          <div
            dangerouslySetInnerHTML={{ __html: blogData.page_content[0]?.html }}
          />
        ) : (
          <LoadingScreen />
        )}
      </div>
    </>
  );
};

export default BlogLayout;
